import React from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useKey, useSetState, useMount } from 'react-use'
import AppError, { ERROR_TYPE } from 'lib/errors'
import { getLocale } from 'lib/utils/getLocale'

import ErrorComponent from './ErrorComponent'

const TYPES = Object.freeze([ERROR_TYPE.NETWORK, ERROR_TYPE.INTERNAL, ERROR_TYPE.MY_NETTIX])

export const DevErrorViewContext = React.createContext()

const DevErrorView = () => {
    const history = useHistory()
    const location = useLocation()
    const params = useParams()
    const { t, i18n } = useTranslation('errors')

    const [state, setState] = useSetState({
        errorTransData: null,
    })

    const gotoError = (type, code) => {
        history.push({
            ...location,
            pathname: `${getLocale(i18n.language)}/dev/error/${type}/${code}`
        })
    }

    useKey('ArrowRight', () => {
        const errors = state.errorTransData[params.type]
        const keys = Object.keys(errors)
        const nextIndex = keys.indexOf(params.code) + 1
        const nextKey = keys[nextIndex]

        if (nextKey) {
            gotoError(params.type, nextKey)
        } else {
            const nextTypeIndex = TYPES.indexOf(params.type) + 1
            const nextType = TYPES[nextTypeIndex] || TYPES[0]
            const nextTypeFirstCode = Object.keys(state.errorTransData[nextType])[0]

            gotoError(nextType, nextTypeFirstCode)
        }
    }, {}, [state, params])

    useKey('ArrowLeft', () => {
        const errors = state.errorTransData[params.type]
        const keys = Object.keys(errors)
        const prevIndex = keys.indexOf(params.code) - 1
        const prevKey = keys[prevIndex]

        if (prevKey) {
            gotoError(params.type, prevKey)
        } else {
            const prevTypeIndex = TYPES.indexOf(params.type) - 1
            const prevType = TYPES[prevTypeIndex] || TYPES[TYPES.length - 1]
            const prevTypeLastCode = Object.keys(state.errorTransData[prevType])[Object.keys(state.errorTransData[prevType]).length - 1]

            gotoError(prevType, prevTypeLastCode)
        }
    }, {}, [state, params])

    // Get errors from translation file
    useMount(() => {
        const errorTransData = {}

        TYPES.forEach((type) => {
            errorTransData[type] = t(`errors:${type.toLowerCase()}`, { returnObjects: true })
        })

        setState({ errorTransData: { ...errorTransData } })
    })

    const appError = new AppError(params.type, parseInt(params.code), 'Backend error message not available.', false, {})

    return (
        <DevErrorViewContext.Provider value={true}>
            <div className="dev-error-view">
                <div className="dev-error-view__error-page">
                    <ErrorComponent error={appError} errorPage />
                </div>
                <br />
                <br />
                <br />
                <br />
                <div className="dev-error-view__error-message">
                    <ErrorComponent error={appError} errorPage={false} />
                </div>
            </div>
        </DevErrorViewContext.Provider>
    )
}

export default DevErrorView
